import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  makeStyles,
  Box,
} from "@material-ui/core";
import { colors } from "../../../../components/theme";

import moment from "moment-timezone";

// (Opcional) Si usas Dropzone u otro:
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton, Menu, MenuItem } from "@mui/material";
import PrintIcon from "@material-ui/icons/Print";
import GetAppIcon from "@material-ui/icons/GetApp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CloseIcon from "@material-ui/icons/Close";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { getMimeType } from "../../helpers/mimeTypes";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  dropArea: {
    border: "2px dashed #ccc",
    borderRadius: 8,
    textAlign: "center",
    padding: theme.spacing(4),
    color: "#555",
    cursor: "pointer",
  },
  uploadIcon: {
    fontSize: 40,
    color: theme.palette.primary.main,
  },
  hiddenInput: {
    display: "none", // para ocultar el input file
  },
  modalContainer: {
    height: "calc(100vh - 300px)",
  },
  actionText: {
    fontSize: "14px",
    marginLeft: "4px",
  },
}));

export default function CompletedFormDialog({
  open,
  onClose,
  onUpload,
  requestedDocumentsByTemplate,
}) {
  const classes = useStyles();

  const download = async (value) => {
    try {
      console.log("Downloading:", value);

      // Check if we have the required data
      if (!value.pathUrl || (!value.pathUrl.Pdf && !value.pathUrl.pdf)) {
        console.error("No PDF URL found in:", value);
        alert("No se encontró el archivo para descargar");
        return;
      }

      const downloadURL = value.pathUrl.Pdf || value.pathUrl.pdf;
      const fileName = value.templateName || "documento";

      // Fetch the file as a blob
      const response = await fetch(downloadURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();

      // Create blob URL and download
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = `${fileName}.pdf`;

      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the blob URL
      window.URL.revokeObjectURL(blobURL);

      console.log("Download completed for:", fileName);
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Error al descargar el archivo. Por favor, inténtelo de nuevo.");
    }
  };

  const viewFile = async (row) => {
    console.log("row", row);
    //open a new tab with the url
    window.open(row.pathUrl.Pdf, "_blank");
  };

  const print = async (value) => {
    try {
      console.log("Printing:", value);

      // Check if we have the required data
      if (!value.pathUrl || (!value.pathUrl.Pdf && !value.pathUrl.pdf)) {
        console.error("No PDF URL found in:", value);
        alert("No se encontró el archivo para imprimir");
        return;
      }

      const printURL = value.pathUrl.Pdf || value.pathUrl.pdf;
      const fileName = value.templateName || "documento";

      // Fetch the file as a blob
      const response = await fetch(printURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();

      // Create blob URL
      const blobURL = window.URL.createObjectURL(blob);

      // Create a temporary iframe for printing
      const printFrame = document.createElement("iframe");
      printFrame.style.position = "absolute";
      printFrame.style.left = "-9999px";
      printFrame.style.top = "-9999px";
      printFrame.style.width = "100%";
      printFrame.style.height = "100%";
      printFrame.src = blobURL;

      // Add iframe to body
      document.body.appendChild(printFrame);

      // Wait for iframe to load, then print
      printFrame.onload = () => {
        try {
          // Access the iframe's window and print
          const iframeWindow = printFrame.contentWindow;
          iframeWindow.focus();

          // Use the native print function
          iframeWindow.print();

          console.log("Print dialog opened for:", fileName);

          // Clean up after printing (with delay to ensure print dialog is shown)
          // setTimeout(() => {
          // 	document.body.removeChild(printFrame);
          // 	window.URL.revokeObjectURL(blobURL);
          // }, 5000);
        } catch (printError) {
          console.error("Error in print operation:", printError);
          // Clean up on error
          document.body.removeChild(printFrame);
          window.URL.revokeObjectURL(blobURL);
          alert("Error al imprimir. Por favor, inténtelo de nuevo.");
        }
      };
    } catch (error) {
      console.error("Error printing file:", error);
      alert("Error al imprimir el archivo. Por favor, inténtelo de nuevo.");
    }
  };

  const downloadCSV = () => {
    try {
      if (
        !requestedDocumentsByTemplate ||
        requestedDocumentsByTemplate.length === 0
      ) {
        alert("No data available for download");
        return;
      }

      // Define CSV headers
      const headers = ["Email", "Status", "Completed At", "Template Name"];

      // Convert data to CSV format
      const csvContent = [
        headers.join(","), // Header row
        ...requestedDocumentsByTemplate.map((row) =>
          [
            `"${row.email || ""}"`,
            `"${row.status || ""}"`,
            `"${
              row.completedAt
                ? moment
                    .tz(row.completedAt, "UTC")
                    .tz("America/New_York")
                    .format("MM/DD/yyyy hh:mm:ss")
                : ""
            }"`,
            `"${row.templateName || ""}"`,
          ].join(",")
        ),
      ].join("\n");

      // Create and download the CSV file
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "completed_forms.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading CSV:", error);
      alert("Error downloading CSV file. Please try again.");
    }
  };

  const RowActionsMenu = ({ row }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleView = () => {
      viewFile(row);
      handleClose();
    };

    const handleDownload = () => {
      download(row);
      handleClose();
    };

    const handlePrint = () => {
      print(row);
      handleClose();
    };

    return (
      <div>
        <IconButton color="primary" onClick={handleOpen} size="small">
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem onClick={handleView} style={{ color: colors.blue }}>
            <VisibilityIcon style={{ marginRight: 8 }} /> View
          </MenuItem>
          <MenuItem onClick={handleDownload} style={{ color: colors.blue }}>
            <GetAppIcon style={{ marginRight: 8 }} /> Download
          </MenuItem>
          <MenuItem onClick={handlePrint} style={{ color: colors.blue }}>
            <PrintIcon style={{ marginRight: 8 }} /> Print
          </MenuItem>
        </Menu>
      </div>
    );
  };

  const headCols = [
    {
      field: "email",
      headerClassName: "MuiTableHead-root",
      headerName: "Email",
      minWidth: "25%",
      width: "25%",
      disableColumnResizable: true,
      flex: 1,
    },
    {
      field: "templateName",
      headerClassName: "MuiTableHead-root",
      headerName: "Document",
      disableColumnResizable: true,
      minWidth: "25%",
      width: "25%",
      flex: 1,
    },
    {
      field: "completedAt",
      headerClassName: "MuiTableHead-root",
      headerName: "Date",
      disableColumnResizable: true,
      minWidth: "20%",
      width: "20%",
      flex: 1,
      default: "2023-10-01",
      renderCell: (params) => {
        return (
          <span>
            {moment
              .tz(params.row.completedAt, "UTC")
              .tz("America/New_York")
              .format("MM/DD/yyyy hh:mm:ss")}
          </span>
        );
      },
    },
    {
      field: "Actions",
      headerClassName: "MuiTableHead-root",
      headerName: "",
      disableColumnResizable: true,
      flex: 0.2,
      renderCell: (params) => {
        return <RowActionsMenu row={params.row} />;
      },
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="create-template-dialog"
    >
      <DialogTitle id="create-template-dialog" disableTypography>
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Typography variant="h6" style={{ margin: 0 }}>
            Completed Forms
          </Typography>
          <div
            style={{
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              style={{ backgroundColor: colors.blue }}
              onClick={downloadCSV}
              size="small"
            >
              Export
            </Button>
            <IconButton
              onClick={onClose}
              size="small"
              style={{ color: "black", backgroundColor: "#e0e0e0" }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </DialogTitle>

      <DialogContent dividers className={classes.dialogContent}>
        <div className={classes.modalContainer}>
          <DataGrid
            rows={requestedDocumentsByTemplate}
            columns={headCols}
            pageSize={10}
            density="compact"
            rowsPerPageOptions={[10]}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                minHeight: "30px !important",
                maxHeight: "30px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                minHeight: "30px !important",
                maxHeight: "30px !important",
                lineHeight: "30px !important",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                lineHeight: "normal",
                whiteSpace: "normal",
                fontSize: "0.875rem",
              },
              "& .MuiDataGrid-virtualScroller": {
                marginTop: "30px !important",
              },
              "& .MuiDataGrid-row": {
                backgroundColor: "#fff !important",
                "&:nth-of-type(even)": {
                  backgroundColor: "#f5f5f5 !important",
                },
                minHeight: "auto !important",
                maxHeight: "auto !important",
              },
              "& .MuiDataGrid-cell": {
                padding: "4px !important",
                fontSize: "14px",
                backgroundColor: "inherit !important",
              },
              border: "none",
              "& .MuiDataGrid-cell": {
                border: "none",
              },
              "& .MuiDataGrid-columnHeaders": {
                borderBottom: "none",
              },
              "& .MuiDataGrid-columnHeader": {
                borderRight: "none",
              },
              "& .MuiDataGrid-virtualScroller": {
                border: "none",
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "none",
              },
            }}
            sortingOrder={["asc", "desc"]}
            getRowClassName={() => `MuiTableCell-row`}
            initialState={{
              sorting: {
                sortModel: [{ field: "name", sort: "asc" }],
              },
            }}
          />
        </div>
      </DialogContent>
      {/* 
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    onClick={handleUploadClick}
                    color="primary"
                          style={{ backgroundColor: colors.blue }}
                    variant="contained"
                    disabled={!templateName || !selectedFile} // Habilitado si hay nombre y archivo
                >
                    Upload
                </Button>
            </DialogActions> */}
    </Dialog>
  );
}
